<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M5.25 4.5h7.5L8.993 9.225 5.25 4.5Zm-2.062-.293C4.703 6.15 7.5 9.75 7.5 9.75v4.5c0 .412.338.75.75.75h1.5c.412 0 .75-.338.75-.75v-4.5s2.79-3.6 4.305-5.543A.748.748 0 0 0 14.213 3H3.78a.748.748 0 0 0-.592 1.207Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
